import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./Bill/Main";
import Form from "./Bill/Form";

// แยกเฉพาะโรงน้ำ
import FormWater from "./Bill/FormWater";

// Utils
import {
  getDataWithComp,
  getMaxDocNo,
  getAlert,
} from "../../../utils/SamuiUtils";

import { getReport } from "../../../utils/ReportUtils";
import Navbar from "../../components/Modal/Navbar";

const Bill = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [maxBiNo, setMaxBiNo] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp(
        "API_1301_BL_H",
        `ORDER BY Doc_Id DESC`
      );
      if (masterList && masterList.length > 0) {
        console.debug("masterList", masterList);
        setDataMasterList(masterList);
      }

      // หาค่าสูงของ DocNo ใน BL_H สำหรับ BI (ใบวางบิล)
      const maxBi = getMaxDocNo(masterList, "BI");
      setMaxBiNo(maxBi);
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onPageUpdate = (docNo) => {
    setMaxBiNo(docNo);
    setMode("U");
  };

  return (
    <div>
      <div className="Invoice">
        <div className="wrapper">
          <Navbar />
          <div className="main-panel">
            <div className="container">
              <div className="page-inner">
                {mode === "S" ? (
                  <Main
                    name={"ใบวางบิล"}
                    dataMasterList={dataMasterList}
                    onPageInsert={() => onPageInsert()}
                    onPageUpdate={(docNo) => onPageUpdate(docNo)}
                  />
                ) : (
                  <>
                    {localStorage.getItem("company") === "1" ? (
                      <FormWater
                        callInitialize={initialize}
                        mode={mode}
                        name={"ใบวางบิล"}
                        docNo={maxBiNo}
                        getReport={getReport}
                      />
                    ) : (
                      <Form
                        callInitialize={initialize}
                        mode={mode}
                        name={"ใบวางบิล"}
                        docNo={maxBiNo}
                        getReport={getReport}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bill;
